import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  
`;

/** Breathing room between accordion header row and inner content (Figma formula tab). */
export const SectionBody = styled.div`
  padding: 0 ${spacing[2]} ${spacing[3]} ${spacing[3]};
`;

export const FormulaExpression = styled.div`
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${rawColors.primary[100]};
  border-radius: ${borderRadius.md};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  word-break: break-word;
`;

const emptyHintStyles = `
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

/** Standalone empty state (e.g. associated columns section with no grid). */
export const EmptyHint = styled.p`
  ${emptyHintStyles}
  padding: ${spacing[3]};
`;

/** Empty state inside SectionBody — parent supplies padding. */
export const BodyEmptyHint = styled.p`
  ${emptyHintStyles}
`;

export const ColumnsGridWrap = styled.div`
  padding: ${spacing[3]};
`;
